import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';

import { AppData } from './app-data';
import { ColumnDefinitionHttpService } from './services/http/common/column-definition.http.service';
import { ConfigValuesHttpService } from './services/http/common/config-values.service';
import { TableDefinitionHttpService } from './services/http/common/table-definition.http.service';
import { AuthenticationService } from './services/authentication.service';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RouteHttpService } from './services/http/common/route.http.service';
import { CustomINavData } from './model/common/custom-nav';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  // tslint:disable-next-line
  selector: 'app-root',
  templateUrl: './app.component.html',
  // template: '<router-outlet></router-outlet>',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {

  public sidebarMinimized = false;
  // public navItems = navItems;
  public customNavItems = null;
  public tokenExpired = '';
  public token = '';
  decodedToken: any;
  public roleName = '';
  userName = '';


  constructor(
   public router: Router,
    public iconSet: IconSetService,
    public tableDefinitionHttpService: TableDefinitionHttpService,
    public columnDefinitionHttpService: ColumnDefinitionHttpService,
    public configValuesHttpService: ConfigValuesHttpService,
    public authenticationService: AuthenticationService,
    private jwtService: JwtHelperService,
    private routeService: RouteHttpService,
    private activatedRoute: ActivatedRoute,
    //private location: Location,
  ) {
    iconSet.icons = { ...freeSet };

    //var path = location.path();
    this.authenticationService.isSignedIn()
    .subscribe((data) => {
      // alert(data);
      AppData.UserIsSignedIn = data;
      if (AppData.UserIsSignedIn) {
        this.token = localStorage.getItem('id_token');
        // this.getTokenExpirationDate(this.token);
        // this.timeout();
        this.loadData();
      } else {
        // alert('redirect');
        //alert(path);
        //this.router.navigate(['']);
      }
    });
    this.authenticationService.getUser().pipe(
        map((user: any) => {
          return user;
        }))
        .subscribe((data: any) => {
          AppData.UserId = data.sub;
        });

    this.authenticationService.getRoles().pipe(
        map((roles: string) => {
          return roles;
        }))
        .subscribe((data: string) => {
          AppData.UserIsAdmin = data.indexOf("administrator") != -1;
          AppData.UserRoles = data;
        });
  }

  ngOnInit() {
    let currentUrl = this.router.location.path();
    //let currentUrl = this.location.path();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate([currentUrl]));
    this.timeout();
  }

//   reloadCurrentRoute() {
//     let currentUrl = this.router.url;
//     this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
//         this.router.navigate([currentUrl]);
//     });
// }

private loadTableConfigurationData() {
  this.authenticationService.userInfo();

  this.decodedToken = this.jwtService.decodeToken(this.token);

  let index = this.decodedToken.role[1];

  if (index.length > 1) {
    this.decodedToken.role = this.decodedToken.role.slice(0 , -1);
  }

    this.routeService.getData(this.decodedToken.role).subscribe((routes: CustomINavData[]) => {
         
      this.customNavItems = [];
      routes.forEach(u => u.children.length === 0 ? delete u.children : u);
      this.customNavItems = routes;

      //   this.tableDefinitionHttpService.get(1, 1000000, 'id', 'asc', null)
      // .subscribe((tableDefinitions: PagedResult<TableDefinition>) => {

      //   let params: Array<Param> = new Array<Param>();
      //   params.push(new Param('roleName', decodedToken.role));
      //   this.columnDefinitionHttpService.get(1, 1000000, 'tableDefinitionId', 'asc', params)
      //     .subscribe((columnDefinitions: PagedResult<ColumnDefinition>) => {
      //       AppData.UpdateColumnDefinitions(tableDefinitions.items, columnDefinitions.items);

      //       this.configValuesHttpService.get(1, 1000000, 'id', 'asc', params)
      //         .subscribe((configValues: PagedResult<ConfigValue>) => {
      //           AppData.UpdateConfigValues(configValues.items);

      //         });
      //     });        
      // });
    });  
}

toggleMinimize(e) {
  this.sidebarMinimized = e;
}

signout(): void {
  this.routeService.getData('logout').subscribe((routes: CustomINavData[]) => {
    this.customNavItems = [];
    routes.forEach(u => u.children.length === 0 ? delete u.children : u);
    this.userName = '';
    this.decodedToken = null;
    this.customNavItems = routes;
    this.authenticationService.signout();
    this.router.navigate(['']);
  });  
}

refresh(): void{
  this.loadTableConfigurationData();
}

private loadData() {
  this.decodedToken = this.jwtService.decodeToken(this.token);
  this.userName = this.decodedToken.name;
  this.getTokenExpirationDate();
  // alert(this.userName);
  let index = this.decodedToken.role[1];

  if (index.length > 1) {
    this.decodedToken.role = this.decodedToken.role.slice(0 , -1);
  }

    this.routeService.getData(this.decodedToken.role).subscribe((routes: CustomINavData[]) => {
      this.customNavItems = [];
      
      routes.forEach(u => u.children.length === 0 ? delete u.children : u);
      this.customNavItems = routes;
    });  
}


public getTokenExpirationDate(): Date {
  if(this.decodedToken != null){
  if (this.decodedToken.exp === undefined) { return null; }
  this.userName = this.decodedToken.name;
  const date = new Date(0);
  date.setUTCSeconds(this.decodedToken.exp);
  this.calculateRemainingTime(new Date(), date);
  // return date;
  }else{
    this.signout();
  }
  
}


public calculateRemainingTime(startDate, endDat) {

let diffMs = (endDat - startDate); // milliseconds
let diffDays = Math.floor(diffMs / 86400000); // days
let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
// console.log(diffDays + " days, " + diffHrs + " hours, " + diffMins + "minutes");
// this.tokenExpired = diffDays + " days, " + diffHrs + " hours, " + diffMins + "minutes";
this.tokenExpired = diffHrs + " hours, " + diffMins + " minutes";

if (diffDays == 0 && diffHrs === 0 && diffMins === 0) {
  // console.log('A expirat sesiunea!');
  this.signout();
}
}

timeout() {
// alert(AppData.UserIsSignedIn);      
if(AppData.UserIsSignedIn) {
  setTimeout(() => {
     this.getTokenExpirationDate();
     this.timeout();
}, 6000 * 5);     
}
}

}
